/**
 * The current storyboard schema version
 */
export const VERSION = 8;
